import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import headerLayoutWrapper from "../hoc/headerLayoutWrapper";
import Loading from "../components/loading";
import {
  getPrefix,
  addPrefix,
  updatePrefix,
  deletePrefix,
} from "../services/services";
import PrefixModal from "./Modal/PrefixModal";
import { confirmDelete } from "../components/confirmDelete";
import DataTable from "react-data-table-component";

const Prefix = () => {
  const [prefixes, setPrefixes] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [editingId, setEditingId] = useState(null);
  const [formData, setFormData] = useState({ name: "", type: "product" });

  const fetchPrefixes = async () => {
    try {
      setLoading(true);
      const res = await getPrefix();
      if (res.data.status) {
        setPrefixes(res.data.prefixes);
      }
    } catch {
      toast.error("Failed to load prefixes");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchPrefixes();
  }, []);

  // Save Add / Update
  const handleSave = async (data) => {
    try {
      const payload = { name: data.name, type: data.type };

      if (editingId) {
        const res = await updatePrefix(editingId, payload);
        toast.success(res.data.message);
      } else {
        await addPrefix(payload);
        toast.success("Prefix added");
      }

      setShowModal(false);
      setEditingId(null);
      setFormData({ name: "", type: "product" });
      fetchPrefixes();
    } catch (err) {
      toast.error(err.response?.data?.error || "Save failed");
    }
  };

  const handleEdit = (prefix) => {
    setEditingId(prefix._id);
    setFormData({ name: prefix.name, type: prefix.type });
    setShowModal(true);
  };

  const handleDelete = async (id, name) => {
    const isConfirmed = await confirmDelete(`${name}?`);
    if (!isConfirmed) return;

    try {
      await deletePrefix(id);
      toast.success("Prefix deleted successfully");
      fetchPrefixes();
    } catch {
      toast.error("Delete failed");
    }
  };

  // ✅ DataTable Styles (Uppercase Heading)
  const customStyles = {
    headCells: {
      style: {
        backgroundColor: "#0b2b6d",
        color: "#fff",
        fontWeight: "600",
        textTransform: "uppercase",
        fontSize: "13px",
      },
    },
  };

  // ✅ DataTable Columns
  const columns = [
    {
      name: "S. No.",
      cell: (row, index) => index + 1,
      width: "80px",
    },
    {
      name: "Prefix Name",
      selector: (row) => row.name,
      sortable: true,
    },
    {
      name: "Type",
      cell: (row) => (
        <span className="fw-bold text-dark">{row.type.toUpperCase()}</span>
      ),
    },
    {
      name: "Action",
      cell: (row) => (
        <div className="d-flex gap-1">
          <button
            className="btn btn-light btn-sm border"
            onClick={() => handleEdit(row)}
          >
            <i className="bi bi-pencil"></i>
          </button>

          <button
            className="btn btn-light btn-sm border text-danger"
            onClick={() => handleDelete(row._id, row.name)}
          >
            <i className="bi bi-trash"></i>
          </button>
        </div>
      ),
    },
  ];

  if (loading) return <Loading />;

  return (
    <>
      <div id="main">
        <div className="d-flex justify-content-between align-items-center mb-3">
          <h4>Manage Prefix</h4>

          <button
            className="btn btn-primary"
            onClick={() => setShowModal(true)}
          >
            Add Prefix
          </button>
        </div>

        <div className="card shadow-sm">
          <div className="card-body p-0 rounded">
            <DataTable
              columns={columns}
              data={prefixes}
              customStyles={customStyles}
              highlightOnHover
              noDataComponent={
                <div className="py-4 text-muted text-center">
                  <i className="bi bi-inbox fs-1 mb-2 d-block"></i>
                  No prefix found
                </div>
              }
              striped
              responsive
            />
          </div>
        </div>
      </div>

      {/* Modal */}
      <PrefixModal
        show={showModal}
        onClose={() => {
          setShowModal(false);
          setEditingId(null);
        }}
        type="prefix"
        value={formData}
        onChange={setFormData}
        onSave={handleSave}
        title={editingId ? "Edit Prefix" : "Add Prefix"}
        label="Prefix Name"
        placeholder="Enter prefix (e.g. INV)"
        showTypeDropdown={true}
      />
    </>
  );
};

export default headerLayoutWrapper(Prefix);
